module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Forward-3658cb1ca4dcd33f07c542395abab3e9.svg";